export default els => Array.prototype.forEach.call(els, (el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault()
    const url = el.getAttribute('data-mv-print')
    window.open(url, '_blank')
  })
})
